export default {
    external_resource_url: 'external_resource_url',
}



// WEBPACK FOOTER //
// ./src/Enum/OtAttributeTypes.js